const EnvironmentActionTypes = {
  SET_ENV: 'SET_ENV',
  SET_APP_VIEW: 'SET_APP_VIEW',
  SET_APP_TYPE: 'SET_APP_TYPE',
  RESET: 'RESET',
};

export default EnvironmentActionTypes;
